import http from "@/utils/http.js"

//查询导航栏
export function getNavList(data) {
	return http({
		url: "/api/web/configCategory/list",
		method: "GET",
		data: data,
	})
}

//查询面包屑
export function getCategoryList(data) {
	return http({
		url: "/api/web/configCategory/getCategoryList",
		method: "POST",
		data: data
	})
}

// 通过code查询导航栏
export function getNavItemByCode(code) {
	return http({
		url: "/api/web/configCategory/item/" + code,
		method: 'GET',
	})
}

